export default "__VITE_ASSET__BJTSZrOc__"